import { Helmet } from "react-helmet";
import { Heading, Img, Button } from "../../components";
import CarAdsTable from "../../components/CarAdsTable";
import TestFile2AfterColumntwenty from "../../components/TestFile2AfterColumntwenty";
import TestFile2AfterRowTwo from "../../components/TestFile2AfterRowTwo";
import React, { Suspense, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AddNewCarModal from "../../components/modals/AddNewCarModal";
import { API_DOMAIN } from "config";
import LimitPopup from "components/LimitPopup.jsx";

export default function RightSideMenuProvider({
  currentUser,
  handleLogout,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const userName = localStorage.getItem("userName");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [limitPopup, setLimitPopup] = useState({
    open: false,
    title: "",
    message: "",
    nextAllowedAt: null,
  });

  const isPath = (path) => location.pathname === path;
  const activeItemClass = "bg-[#4A4A4A] rounded-[12px]";
  const itemBaseClass = isMobile
    ? "tooltip flex w-full flex-row-reverse items-center justify-start gap-3 cursor-pointer p-3.5 rounded-lg"
    : "tooltip flex flex-col items-center cursor-pointer p-3.5";
  const textClass = isMobile ? "menu-text-mobile" : "tooltip-text";
  const menuClasses = `
    right-side-menu-dealer provider flex w-[5%] flex-col gap-[20px] rounded-[16px] bg-black-900_03 py-7 md:w-full md:gap-[126px] sm:gap-[84px] sm:py-4
    ${isMobile ? (mobileOpen ? "open" : "closed") : "desktop"}
  `;

  useEffect(() => {
    const media = window.matchMedia("(max-width: 768px)");
    const onChange = (e) => setIsMobile(e.matches);

    setIsMobile(media.matches);
    media.addEventListener?.("change", onChange);

    return () => media.removeEventListener?.("change", onChange);
  }, []);

  useEffect(() => {
    if (isMobile) setMobileOpen(false);
  }, [location.key, isMobile]);

  const closeMobileMenu = () => {
    if (isMobile) setMobileOpen(false);
  };

  const go = (path) => {
    closeMobileMenu();
    navigate(path);
  };

  const providerLabel =
    currentUser?.provider_type === "private" ? "מוכר פרטי" : "ספק";

  const handleOpenAddCar = async () => {
    try {
      closeMobileMenu();

      const userId = currentUser?.id;
      const res = await fetch(`${API_DOMAIN}/car/canAddCarApi`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: new URLSearchParams({ user_id: String(userId) }).toString(),
      });

      const data = await res.json();

      if (!data.allowed) {
        setLimitPopup({
          open: true,
          title: "הוספת רכב מוגבלת",
          message:
            data.message || "מוכר פרטי יכול להעלות רכב אחד בלבד בכל 30 ימים.",
          nextAllowedAt: data.next_allowed_at || null,
        });
        return;
      }

      setIsPopupOpen(true);
    } catch (e) {
      console.error(e);
      setLimitPopup({
        open: true,
        title: "שגיאה",
        message: "אירעה שגיאה בבדיקת המכסה. נסי שוב.",
        nextAllowedAt: null,
      });
    }
  };

  return (
    <div>
      {isMobile && (
        <button
          className="hamburger-btn"
          onClick={() => setMobileOpen((open) => !open)}
        >
          <Img src="/images/img_megaphone_gray_600.svg" alt="menu" />
        </button>
      )}

      <div className={menuClasses}>
        <div className="flex flex-col gap-[10px] lg:gap-[10px] md:gap-[10px] sm:gap-9">
          <div className="wrap-img-icon flex flex-col items-center justify-center gap-1.5 px-3 cursor-pointer">
            <Img
              src="/images/img_uuid_8da7836a_2_red_700.png"
              alt="Uuid8da7836atwo"
              className="img-icon h-[28px] w-full object-cover lg:h-auto md:h-auto"
            />
            <Heading
              size="heading9xl"
              as="h2"
              className="!font-montserrat text-[25.98px] font-extrabold !text-red-a700_01 lg:text-[21px]"
            >
              <span className="text-secondary-primary_white">B</span>
              <span className="text-red-a700_03">M</span>
              <span className="text-secondary-primary_white">C</span>
            </Heading>
          </div>

          <div className="wrap-all wrap-all-menu-provider mx-4 flex flex-col items-center gap-6 md:mx-0">
            <div
              className={`wrap-icons-menu flex flex-col gap-1 ${
                isMobile ? "w-full items-stretch" : "items-center"
              }`}
            >
              <div
                className={`${itemBaseClass} mt-3`}
                onClick={handleOpenAddCar}
              >
                <Img src="/images/img__20x20.svg" alt="הוספת רכב" className="h-[20px]" />
                <span className={textClass}>הוספת רכב</span>
              </div>

              <div
                className={`${itemBaseClass} ${
                  isPath("/provider-cars") ? activeItemClass : ""
                } mt-3`}
                onClick={() => go("/provider-cars")}
              >
                <Img src="/images/img__2.svg" alt="רכבים" className="h-[20px]" />
                <span className={textClass}>רכבים</span>
              </div>

              <div
                className={`${itemBaseClass} ${
                  isPath("/recived-offers") ? activeItemClass : ""
                } mt-3`}
                onClick={() => go("/recived-offers")}
              >
                <Img src="/images/img__4.svg" alt="הצעות לרכבים" className="h-[20px]" />
                <span className={textClass}>הצעות לרכבים</span>
              </div>

              <div
                className={itemBaseClass}
                onClick={handleLogout}
                style={!isMobile ? { display: "none" } : {}}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="shrink-0"
                >
                  <path
                    d="M15 3H10C6.686 3 4 5.686 4 9V15C4 18.314 6.686 21 10 21H15"
                    stroke="white"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21 12H9"
                    stroke="white"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18 8L22 12L18 16"
                    stroke="white"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className={textClass}>התנתקות</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className="mt-auto flex w-full flex-col items-center justify-center md:mx-0 cursor-pointer logout-button hide-mobile"
          style={isMobile ? { display: "none" } : {}}
        >
          <div
            className="flex flex-col items-center justify-center"
            style={{ width: "100%", height: "auto", marginBottom: "5px", padding: "0" }}
          >
            <Heading
              size="headingxl"
              as="h3"
              className="!font-assistant text-[15px] font-semibold !text-secondary-primary_white"
              style={{ fontSize: "15px" }}
            >
              {currentUser?.name || userName}
            </Heading>
            <Heading
              size="headinglg"
              as="h4"
              className="!font-assistant text-[15px] font-semibold !text-yellow-800"
            >
              {providerLabel}
            </Heading>
          </div>

          <Heading
            onClick={handleLogout}
            size="textxs"
            as="h5"
            className="!font-assistant text-[13px] font-medium !text-white-a700_7f underline"
          >
            התנתקות
          </Heading>
        </div>
      </div>

      {isPopupOpen && (
        <AddNewCarModal
          onClose={() => setIsPopupOpen(false)}
          currentUser={currentUser}
        />
      )}

      <LimitPopup
        open={limitPopup.open}
        title={limitPopup.title}
        message={limitPopup.message}
        nextAllowedAt={limitPopup.nextAllowedAt}
        onClose={() => setLimitPopup((popup) => ({ ...popup, open: false }))}
      />
    </div>
  );
}
